import React, { CSSProperties, ReactNode } from "react";
import { BarsOutlined, DownOutlined } from "@ant-design/icons";
import Dropdown from "antd/lib/dropdown";
import Button from "antd/lib/button";
import { DropDownProps } from "antd/lib/dropdown";
import { MenuProps } from "antd/lib/menu";

interface DropOptionProps {
  onMenuClick: (param: any) => void;
  menuOptions: Array<any>;
  buttonStyle?: CSSProperties;
  dropdownProps?: DropDownProps;
  buttonIcon?: ReactNode;
}

const DropOption: React.FC<DropOptionProps> = (props) => {
  const { onMenuClick, menuOptions, dropdownProps, buttonIcon } = props;

  const menuItems: MenuProps["items"] = menuOptions.map((item) => {
    return {
      key: item.key,
      label: item.name,
      icon: item.icon,
    };
  });

  let buttonStyle: CSSProperties = { border: "none" };
  if (props.buttonStyle != null) {
    buttonStyle = Object.assign(buttonStyle, props.buttonStyle);
  }

  return (
    <Dropdown
      menu={{ items: menuItems, onClick: onMenuClick }}
      {...dropdownProps}
    >
      <Button style={buttonStyle}>
        {buttonIcon ? (
          buttonIcon
        ) : (
          <>
            <BarsOutlined style={{ marginRight: 2 }} />
            <DownOutlined />
          </>
        )}
      </Button>
    </Dropdown>
  );
};

export default DropOption;
